/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React, { useEffect } from 'react';
import mbpLogger from '@module-logger/mbp';
import { useDispatch, useSelector } from 'react-redux';
import { func } from 'prop-types';
import useSalesforcePersonalizedContentQuery from '../../../../../../../../helpers/Personalization/useSalesforcePersonalizedContentQuery';
import { getCurrentPageType } from '../../../../../../../../../state/ducks/TagManager/ducks/TagManager/TagManager-Selectors';
import { getBrandName } from '../../../../../../../../../state/ducks/App/ducks/Brand/Brand-Selectors';
import { setNewProductCardLayoutEnabled } from '../../../../../../../../../state/ducks/App/App-Actions';
import { getNewProductCardLayoutEnabled } from '../../../../../../../../../state/ducks/App/App-Selectors';
import useClickStreamCustomEventsTracking from '../../../../../../../../helpers/Personalization/useClickstreamCustomEventsTracking';

const NewProductSFAbTest = ({ trackEvent }) => {
    const dispatch = useDispatch();
    const pageType = useSelector(getCurrentPageType);
    const brand = useSelector(getBrandName) || '1800flowers';
    const interactionName = `${brand} - any - precheckout - new product card - v1`;
    const newProductCardEnabled = useSelector(getNewProductCardLayoutEnabled);
    const { loading, data, error } = useSalesforcePersonalizedContentQuery({
        queryName: 'isNewProductCardUpdate',
        interactionName,
        featureFlag: true,
        optInHoldoutParticipation: false,
        resolveIdentity: false,
    });
    useClickStreamCustomEventsTracking({
        salesforceResponse: data?.contentSF,
        isFireImpression: true,
        page: { type: pageType },
    });

    if (error) {
        mbpLogger.logError({
            function: 'Product Card Price Update',
            appName: process.env.npm_package_name,
            module: 'mbp-checkout',
            message: 'Product Card Salesforce AB test returned an error',
            jsError: error,
        });
    }
    const campaignResponse = data?.contentSF?.campaign?.campaignResponses?.[0]?.payload?.userGroup;
    const currentUserGroup = newProductCardEnabled?.campaign?.campaignResponses?.[0]?.payload?.userGroup;

    useEffect(() => {
        if (!campaignResponse) return;
        if (campaignResponse === currentUserGroup) return;

        dispatch(setNewProductCardLayoutEnabled(data?.contentSF));
        dispatch(
            trackEvent({
                eventCategory: 'Experiment',
                eventAction: 'Product Card',
                eventLabel: campaignResponse?.toLowerCase() === 'test' ? 'Variant' : 'Control',
                feature_detail: campaignResponse?.toLowerCase() === 'test' ? 'Variant' : 'Control',
                feature_element: 'Product Card',
                feature_category: 'Experiment',
            }),
        );
    }, [campaignResponse, currentUserGroup]);

    if (loading || (!loading && !data && !error)) {
        return null;
    }

    return null;
};

NewProductSFAbTest.propTypes = {
    trackEvent: func.isRequired,
};

export default NewProductSFAbTest;
